import { LOCAL_STORE_ORDER_ID } from '~/store/order.js'

export default function({ store, app }) {
    const orderId = app.$cookies.get(LOCAL_STORE_ORDER_ID) || null
    store.commit('order/setOrderId', orderId)
}
